import React from 'react';
import './EmptyLibraryItemsListCard.scss';

const EmptyLibraryItemsListCard = ({ children }) => {
  return (
    <div className="empty-library-items-list-card content-container">
      <div className="empty-library-items-list-text">
        Add analysis data to the library using the Junction Excel add-in, or
        import the content from PowerPoint and Power BI below.
      </div>
      {children}
    </div>
  );
};

export default EmptyLibraryItemsListCard;
